/*
 * Brinde automático do Kit Experiência: põe ou tira o brinde do carrinho.
 *
 * O porquê e a contagem estão em snippets/brinde-kit.liquid, que também escreve
 * `window.brindeKit` antes deste arquivo.
 *
 * Uma regra só, aplicada a cada mudança: com a promoção ligada e o mínimo de
 * pijamas elegíveis, o carrinho tem exatamente 1 brinde; senão, nenhum. Nunca
 * mexe em outra linha.
 *
 * Quem dispara a conferência (são 5 caminhos que mexem no carrinho, e 2 não
 * avisam ninguém):
 *   - o evento cartUpdate: formulário do produto, gaveta e /cart, order bump;
 *   - ao carregar a página, só se o Liquid já viu o carrinho fora da regra:
 *     os reels da home adicionam e redirecionam para /cart;
 *   - ao abrir a gaveta: o patch da página de produto adiciona e redesenha a
 *     gaveta sem publicar evento;
 *   - no "Finalizar a compra": rede de segurança para qualquer caminho
 *     esquecido. Espera no máximo PRAZO_CHECKOUT_MS e segue mesmo se falhar,
 *     porque arriscar um kit é melhor que perder a venda.
 */
(function () {
  var cfg = window.brindeKit;
  if (!cfg || !cfg.produtoId || typeof fetch !== 'function') return;

  var ORIGEM = 'brinde-kit';
  var PRAZO_CHECKOUT_MS = 3000;
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var elegiveis = {};
  (cfg.elegiveis || []).forEach(function (id) {
    elegiveis[String(id)] = true;
  });

  function pedir(caminho, corpo) {
    var opcoes = corpo
      ? {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(corpo),
        }
      : { headers: { Accept: 'application/json' } };
    return fetch(raiz + caminho, opcoes).then(function (r) {
      if (!r.ok) throw new Error('brinde-kit: ' + caminho + ' respondeu ' + r.status);
      return r.json();
    });
  }

  function querBrinde(cart) {
    if (!cfg.ativo || !cfg.varianteId) return 0;
    var qtd = 0;
    cart.items.forEach(function (item) {
      if (elegiveis[String(item.product_id)]) qtd += item.quantity;
    });
    return qtd >= cfg.minimo ? 1 : 0;
  }

  function atualizarIcone(resposta) {
    var html = resposta && resposta.sections && resposta.sections['cart-icon-bubble'];
    var alvo = document.getElementById('cart-icon-bubble');
    if (!html || !alvo) return;
    var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (novo) alvo.innerHTML = novo.innerHTML;
  }

  /* Devolve true se mudou o carrinho. */
  function corrigir() {
    return pedir('cart.js').then(function (cart) {
      var linhas = cart.items.filter(function (item) {
        return String(item.product_id) === String(cfg.produtoId);
      });
      var tem = linhas.reduce(function (soma, item) {
        return soma + item.quantity;
      }, 0);
      var quer = querBrinde(cart);
      if (tem === quer && linhas.length <= 1) return false;

      /*
       * Sempre /cart/update.js, que devolve o carrinho inteiro: quem ouve o
       * cartUpdate espera o carrinho em `cartData` (quick-add-bulk.js lê
       * `cartData.items`). Sem linha de brinde, a chave é a variante, e o
       * update.js adiciona; com linha, a chave é a da linha: a primeira fica
       * com `quer` e as outras zeram.
       */
      var updates = {};
      if (linhas.length === 0) {
        updates[cfg.varianteId] = quer;
      } else {
        linhas.forEach(function (item, i) {
          updates[item.key] = i === 0 ? quer : 0;
        });
      }
      return pedir('cart/update.js', { updates: updates, sections: 'cart-icon-bubble' }).then(function (resposta) {
        atualizarIcone(resposta);
        /* A gaveta e o /cart se redesenham sozinhos com este evento (assets/cart.js, onCartUpdate). */
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: ORIGEM, cartData: resposta });
        }
        return true;
      });
    });
  }

  /* Uma conferência por vez. Eventos que chegam durante uma conferência viram UMA a mais. */
  var fila = Promise.resolve(false);
  var agendada = false;
  function conferir() {
    if (agendada) return fila;
    agendada = true;
    fila = fila
      .catch(function () {})
      .then(function () {
        agendada = false;
        return corrigir();
      })
      .catch(function (erro) {
        console.error(erro);
        return false;
      });
    return fila;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (evento && evento.source === ORIGEM) return;
      conferir();
    });
  }

  if (cfg.precisa) conferir();

  var gaveta = document.querySelector('cart-drawer');
  if (gaveta && typeof MutationObserver === 'function') {
    var aberta = gaveta.classList.contains('active');
    new MutationObserver(function () {
      var agora = gaveta.classList.contains('active');
      if (agora && !aberta) conferir();
      aberta = agora;
    }).observe(gaveta, { attributes: true, attributeFilter: ['class'] });
  }

  /*
   * No "Finalizar a compra": confere antes de sair. Se a conferência MUDOU o
   * carrinho, vai direto para /checkout em vez de enviar o formulário: os
   * `updates[]` do formulário ainda seriam os de antes da mudança, e a Shopify
   * os aplica pela ordem das linhas.
   */
  document.addEventListener(
    'click',
    function (evento) {
      var botao = evento.target.closest && evento.target.closest('button[name="checkout"]');
      if (!botao || botao.dataset.brindeConferido === '1') return;
      evento.preventDefault();
      evento.stopImmediatePropagation();
      var prazo = new Promise(function (resolve) {
        setTimeout(function () {
          resolve(false);
        }, PRAZO_CHECKOUT_MS);
      });
      Promise.race([conferir(), prazo]).then(function (mudou) {
        if (mudou) {
          window.location.href = raiz + 'checkout';
          return;
        }
        botao.dataset.brindeConferido = '1';
        botao.click();
      });
    },
    true
  );
})();
